import {
    ajax,
    ajaxP,
    request,
    ajaxBack
} from '@/utils/request'


// 手机充值列表
export function feePhoneList() {
    return ajax('api/v1/callCharge/h5/list')
}

// 保存vip账号
export function vipSave(params) {
    return ajaxP('api/v1/customers/member', params)
}

// vip充值类型
export function vipTypeList() {
    return ajax('api/v1/member/h5/cate/list')
}

// vip类型详情
export function vipTypeInfo(id) {
    return ajax('api/v1/member/h5/goods/apptype', {
        cateId: id
    })
}

// vip充值面额列表
export function vipList(params) {
    return ajax('api/v1/member/h5/goods/list', params)
}

// 充值方式分类
export function typeList() {
    return ajax('api/v1/oilCard/h5/cate/list')
}

// 价值列表
export function oilPriceList(params) {
    return ajax('api/v1/oilCard/h5/goods/list', {
        cateId: params
    })
}

// 油卡列表
export function oilCardList() {
    return ajax('api/v1/customers/oilCard/h5/list')
}

// 添加油卡
export function addOilCard(params) {
    return ajaxP('api/v1/customers/oilCard', params)
}

// 删除油卡
export function delOilCard(id) {
    return request({
        url: `api/v1/customers/oilCard/${id}`,
        method: 'DELETE'
    }, true)
}

// 获取加油劵列表
export function gasCouponsList() {
    return ajaxBack({
        url: 'api/v1/shop/driveService/h5/list',
        method: "get"
    })
}